import { createClient } from '@supabase/supabase-js'
import { SUPABASE_URL, SUPABASE_ANON_KEY } from './env'

// These will be set from environment variables or user settings
export const supabaseUrl = SUPABASE_URL
const supabaseAnonKey = SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl!, supabaseAnonKey!, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'brian2-auth', // Use consistent storage key to avoid multiple instances warning
  },
  global: {
    headers: {
      // Add custom headers if needed
    },
  },
})

// Listen for auth state changes and log token expiry
supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'TOKEN_REFRESHED') {
    console.log('[Supabase Auth] Token refreshed successfully')
  } else if (event === 'SIGNED_OUT') {
    console.log('[Supabase Auth] User signed out')
  } else if (event === 'USER_UPDATED') {
    console.log('[Supabase Auth] User updated')
  }

  if (session?.expires_at) {
    const expiresIn = session.expires_at - Math.floor(Date.now() / 1000)
    console.log(`[Supabase Auth] Token expires in ${Math.floor(expiresIn / 60)} minutes`)
  }
})

export type Database = {
  public: {
    Tables: {
      tasks: {
        Row: {
          id: string
          user_id: string
          name: string
          raw_name: string | null
          note: string | null
          due_date: string | null
          due_time: string | null
          duration: number | null
          completed: boolean
          status: string | null
          priority: number
          tags: string[] | null
          repeat: any | null
          repeat_id: string | null
          project: string | null
          project_path: string | null
          source: string
          source_url: string | null
          external_id: string | null
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          user_id: string
          name: string
          raw_name?: string | null
          note?: string | null
          due_date?: string | null
          due_time?: string | null
          duration?: number | null
          completed?: boolean
          status?: string | null
          priority?: number
          tags?: string[] | null
          repeat?: any | null
          repeat_id?: string | null
          project?: string | null
          project_path?: string | null
          source: string
          source_url?: string | null
          external_id?: string | null
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          user_id?: string
          name?: string
          raw_name?: string | null
          note?: string | null
          due_date?: string | null
          due_time?: string | null
          duration?: number | null
          completed?: boolean
          status?: string | null
          priority?: number
          tags?: string[] | null
          repeat?: any | null
          repeat_id?: string | null
          project?: string | null
          project_path?: string | null
          source?: string
          source_url?: string | null
          external_id?: string | null
          created_at?: string
          updated_at?: string
        }
      }
    }
  }
}
